export default {
  UPDATE_TOTALS (state, totals) {
    state.totalProjects = totals.total_projects || 0
    state.totalKeywords = totals.total_keywords || 0
    state.totalLinks = totals.total_links || 0
    state.totalReports = totals.total_reports || 0
    state.totalProxies = totals.total_proxies || 0
    state.totalUsers = totals.total_users || 0
  },
  SET_METADATA (state, {origin, formated}) {
    state.userRoles = origin.user_roles
    state.engines = origin.engines
    state.reports = origin.reports
    state.selectEngines = formated.engines
    state.selectUserRoles = formated.userRoles
  }
}



// WEBPACK FOOTER //
// ./src/store/metadata/mutations.js